// extracted by mini-css-extract-plugin
module.exports = {"item":"PropertyListItem_item__35WHO","marked":"PropertyListItem_marked__3zVXI","title":"PropertyListItem_title__3JUp2","controls":"PropertyListItem_controls__26l1J"};